module.exports = __webpack_public_path__ + "static/media/logo-데이터비@2x.5bbd980e.png";